<template>
  <div class="clock-list">
    <div class="clock-item" v-for="(item, key) in clockData" :key="key">
      <div class="bp">
        <div class="hour" :style="'transform: rotateZ('+ item.H_point +'deg)'"></div>
        <div class="min" :style="'transform: rotateZ('+ item.M_point +'deg)'"></div>
        <div class="scd" :style="'transform: rotateZ('+ item.S_point +'deg)'"></div>
        <div class="scale" v-for="item in 60"
             :style="'transform: rotateZ(' + 6 * item + 'deg);' + (item % 5 == 0 ? 'height: 15px; width: 2px; ' : '')"></div>
        <div class="timekey" v-for="item in 12" :style="'transform: rotateZ(' + item * 30 + 'deg)'">
          <div :style="'transform: rotateZ(' + item * -30 + 'deg)'">{{ item}}</div>
        </div>
        <p class="time-show">{{ item.time}}</p>
      </div>
      <p>{{ item.title }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "clock",
    data() {
      return {
        timer: null,
        nowTime: '',
        clockData: [{
          title: '北京',
          diffTime: 0,
          H_point: 0,
          M_point: 0,
          S_point: 0,
          time: '00:00:00',
        }, {
          title: '伦敦',
          diffTime: -28800,
          H_point: 0,
          M_point: 0,
          S_point: 0,
          time: '00:00:00',
        }, {
          title: '莫斯科',
          diffTime: -18000,
          H_point: 0,
          M_point: 0,
          S_point: 0,
          time: '00:00:00',
        }, {
          title: '洛杉矶',
          diffTime: -57600,
          H_point: 0,
          M_point: 0,
          S_point: 0,
          time: '00:00:00',
        }, {
          title: '纽约',
          diffTime: -46800,
          H_point: 0,
          M_point: 0,
          S_point: 0,
          time: '00:00:00',
        }]
      }
    },
    created() {
      this.init();
    },
    mounted() {
      this.$nextTick(() => {
        window.onfocus = () => {
          this.init();
        }
        window.onblur = () => {
          this.clearTime();
        }
      });
    },
    methods: {
      init() {
        this.getNowTime();
      },
      clearTime() {
        clearInterval(this.timer);
        this.timer = '';
      },
      getNowTime() {
        _api.get("/base/common/now").then(res => {
          if (res.code == 0) {
            this.nowTime = Date.parse(new Date(res.data.now)) / 1000;
            this.start();
          } else {
            this.$message.error(res.message);
          }
        });
      },
      start() {
        this.clearTime();
        this.timer = setInterval(() => {
          this.nowTime++;
          for (let data of this.clockData) {
            this.updateTime(data);
          }
        }, 1000);
      },
      updateTime(data) {
        var localTime = this.nowTime + data.diffTime,
          localDate = new Date(localTime * 1000),
          s = localDate.getSeconds(),
          m = localDate.getMinutes(),
          h = localDate.getHours();
        data.H_point = (h + m / 60) * 30;
        data.M_point = (m + s / 60) * 6;
        data.S_point = s * 6;
        data.time = (h < 10 ? '0' + h : h) + ':' + (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
      }
    }
  }
</script>

<style scoped>
  .clock-list {
    font-size: 0;
    overflow: hidden;
    padding-top: 35px;
    margin-left: -25px;
  }

  .clock-item {
    display: inline-block;
    font-size: 20px;
    text-align: center;
    margin: 0 -5px;
    width: 20%;
  }

  .clock-item p {
    margin-top: -30px;
    font-size: 16px;
  }

  .bp {
    position: relative;
    width: 200px;
    height: 200px;
    border: 1px solid black;
    border-radius: 100%;
    margin: -20px auto 0;
    position: relative;
    transform: scale(0.7);
    display: inline-block;

  }

  .time-show {
    position: absolute;
    top: 160px;
    left: 28%;
    border: 1px solid #000;
    padding: 2px 10px;
    color: red;
    font-weight: 600;
  }

  .scale {
    width: 1px;
    height: 10px;
    background: black;
    position: absolute;
    left: 100px;
    top: 0px;
    transform-origin: 0px 100px;
  }

  .timekey {
    position: absolute;
    width: 10px;
    font-size: 10px;
    height: 85px;
    transform-origin: bottom;
    top: 15px;
    left: 95px;
  }

  .scd {
    width: 1px;
    height: 70px;
    position: absolute;
    left: 100px;
    top: 30px;
    transform-origin: bottom;
    background: red;
  }

  .min {
    width: 2px;
    height: 60px;
    position: absolute;
    left: 99px;
    top: 40px;
    transform-origin: bottom;
    background: black;
  }

  .hour {
    width: 3px;
    height: 50px;
    position: absolute;
    left: 98.5px;
    top: 50px;
    transform-origin: bottom;
    background: black;
  }
</style>



// WEBPACK FOOTER //
// clock.vue?69ba48a2